import React from "react";
var __jsx = React.createElement;
import { api__getSimilarPosts } from "@/apis/posts/similar";
import { useTranslation } from "@i18n";
import { useEffect } from "react";
import stl from "./SimilarPosts.module.css";
import { useState } from "react";
import useIsMobile from "@hooks/useIsMobile";
import { useLang } from "@/common/Contexts/LanguageContext";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import { Link } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var SimilarPosts = function SimilarPosts(_ref) {
  var postId = _ref.postId;
  var _ref2 = useFullPageData() || {},
    similarPosts = _ref2.similarPosts;
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useState = useState(similarPosts || []),
    similar = _useState[0],
    setSimilar = _useState[1];
  var isMobile = useIsMobile();
  var _useState2 = useState(true),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var lang = useLang();
  useEffect(function () {
    (similar === null || similar === void 0 ? void 0 : similar.length) === 0 && postId && api__getSimilarPosts(postId, 5).then(function (data) {
      setSimilar(data);
      setLoading(false);
    });
    return function () {
      return setSimilar([]);
    };
  }, [postId]);
  return (similar === null || similar === void 0 ? void 0 : similar.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.outterContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("h2", {
    className: "big"
  }, t("سيارات مشابهة", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.cardContainer
  }, similar.length > 0 && (similar === null || similar === void 0 ? void 0 : similar.map(function (post, i) {
    return i < 4 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      key: post.id,
      post: post,
      rank: i + 1,
      page: 1,
      referralLocation: "similar",
      sectionType: "similar items",
      isAnchor: true
    }));
  })), isMobile && similar.length > 4 && /*#__PURE__*/React.createElement("button", {
    className: [stl.mobileSimilar].join(" "),
    onClick: function onClick() {
      window.location.href = (lang == "ar" ? "" : "/en") + "/car/similar-cars/".concat(postId);
    }
  }, " ", t("إعرض المزيد من السيارات", {
    ns: "web_post_view"
  }))), !isMobile && similar.length > 4 && /*#__PURE__*/React.createElement(Link, {
    className: ["whtBtn", stl.moreSimilar].join(" "),
    to: createUrl("/car/similar-cars/".concat(postId))
  }, t("إعرض المزيد من السيارات", {
    ns: "web_post_view"
  })))) : loading ? /*#__PURE__*/React.createElement("div", {
    className: stl.loaderContainer
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 276,
    numberOfLoaders: "3"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 48
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default SimilarPosts;